import { render, staticRenderFns } from "./CustomerTable.html?vue&type=template&id=eaaf4ad0&scoped=true&external"
import script from "./CustomerTable.js?vue&type=script&lang=js&external"
export * from "./CustomerTable.js?vue&type=script&lang=js&external"
import style0 from "./CustomerTable.css?vue&type=style&index=0&id=eaaf4ad0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaaf4ad0",
  null
  
)

export default component.exports